module.exports = __webpack_public_path__ + "img/paypal.b055d305.png";